<template>
  <div class="centerPage">
    <div class="search flex">
      <span class="tit">用户聊天</span>
      <div class="tipsComm">Tips: 单击鼠标右键可将聊天内容复制至剪切板.</div>
    </div>
    <div class="border">
      <el-tabs tab-position="left" class="tabsLeft" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="first">
          <template slot="label">
            <el-button size="mini" class="changeChat"><img src="../../assets/img/message_chat.png" alt="" width="40">
            </el-button>
          </template>
          <sessionList v-if="activeName=='first'" :chatGroup="chatGroup" :type="type"></sessionList>
        </el-tab-pane>
        <el-tab-pane name="second">
          <template slot="label">
            <el-button size="mini" class="changeChat"><img src="../../assets/img/user_chat.png" alt="" width="40">
            </el-button>
          </template>
          <buddyList v-if="activeName=='second'" @cl="changeTab"></buddyList>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>

import sessionList from './sessionList'
import buddyList from './buddyList'

export default {
  name: "communicateDoc",
  data() {
    return {
      activeName: 'first',
      chatGroup: '',
      type: null
    }
  },
  components: {
    sessionList,
    buddyList
  },
  methods: {
    handleClick(tab) {
      this.activeName = tab.name;
    },
    changeTab(val, item, type) {
      // type(2:群聊 1：私信)
      this.activeName = val;
      this.chatGroup = item
      this.type = type
    }
  }

}
</script>

<style lang="scss" scoped>

.centerPage {
  display: block;
}

.tabsLeft ::v-deep {
  height: 620px;

  .el-tabs__header.is-left {
    margin-right: 0;
    background: rgba(86, 123, 255, 0.5);
    border-radius: 2px 0 0 2px;
    padding: 14px;
  }

  .el-tabs__item {
    padding: 0;
    margin-bottom: 14px;
  }

  .el-tabs__nav-wrap.is-left::after, .el-tabs__active-bar.is-left {
    display: none;
  }

  .el-button.changeChat {
    padding: 0;
    background: rgba(86, 123, 255, 0.3);
    border: none;
  }

  .is-active .el-button.changeChat {
    background: #567BFF;
  }
}

.search {
  justify-content: space-between;
  border: 1px solid #567BFF;
  padding: 0 20px;
  height: 47px;
  line-height: 47px;

  .tit {
    font-size: 17px;
    font-weight: bold;
    color: #567BFF;
  }
}

.border {
  border: 1px solid #567BFF;
  margin-top: 20px;
  padding: 10px 20px 20px;
}

.tipsComm {
  color: red;
  text-align: right;
  font-size: 14px;
}
</style>
